import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor;
/* import __COLOCATED_TEMPLATE__ from './second-factor-edit-security-key.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { MAX_SECOND_FACTOR_NAME_LENGTH } from "discourse/models/user";
import TEMPLATE from "./second-factor-edit-security-key.hbs";
import { setComponentTemplate } from "@ember/component";
let SecondFactorEditSecurityKey = (_class = class SecondFactorEditSecurityKey extends Component {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "loading", _descriptor, this);
    _defineProperty(this, "maxSecondFactorNameLength", MAX_SECOND_FACTOR_NAME_LENGTH);
  }
  editSecurityKey() {
    this.loading = true;
    this.args.model.user.updateSecurityKey(this.args.model.securityKey.id, this.args.model.securityKey.name, false).then(response => {
      if (response.error) {
        return;
      }
      this.args.model.markDirty();
    }).catch(error => {
      this.args.model.onError(error);
    }).finally(() => {
      this.loading = false;
      this.args.closeModal();
    });
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "loading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "editSecurityKey", [action], Object.getOwnPropertyDescriptor(_class.prototype, "editSecurityKey"), _class.prototype)), _class);
export { SecondFactorEditSecurityKey as default };
setComponentTemplate(TEMPLATE, SecondFactorEditSecurityKey);